import { PaginationShipment } from "@/domain/entities/Pagination";
import { AxiosResponse } from "axios";
import { BaseResponseMapper } from "./BaseMapper";
import { ExtraBenefit, FreeInsurance, OnTimeGuarantee, Subscription, Subscriptions } from "@/domain/entities/Subscription";

export class SubscriptionMapper extends BaseResponseMapper {
    public convertSubscriptionsFromApi(
        result: AxiosResponse
    ): Subscriptions {
        const {
            data: { pagination, data },
        } = result
        const paginationShipment = new PaginationShipment({ 
            page: pagination.page, 
            limit: pagination.limit,
            totalItem: pagination.total_item,
            search: pagination.search, 
            status: pagination.status, 
            sort: pagination.sort 
          })
        const subscriptionList: Subscription[] = [];
        if (data.length === 0) {
            return new Subscriptions({
                pagination: paginationShipment,
                data: []
            });
        } else {
            data.map((item: any) => {
                subscriptionList.push(
                    new Subscription({
                        id: item.id,
                        name: item.name,
                        startDate: item.start_date,
                        endDate: item.end_date,
                        price: item.price,
                        discountedPrice: item.discounted_price,
                        programBannerUrl: item.program_banner_url,
                        activeBannerUrl: item.active_banner_url,
                        benefitFlag: item.benefit_flag,
                        extraBenefit: item.extra_benefit,
                        duration: item.duration,
                        createdAt: item.created_at,
                        updatedAt: item.updated_at,
                        createdBy: item.created_by,
                        updatedBy: item.updated_by,
                        status: item.status
                    })
                );
            });
        }

        return new Subscriptions({
            pagination: paginationShipment,
            data: subscriptionList
        });
    }

    public convertSubscriptionDetailFromApi(result: AxiosResponse): Subscription {
        const { data } = result
        const freeInsurance = data.extra_benefit.free_insurance
        return new Subscription({
            id: data.id,
            name: data.name,
            startDate: data.start_date,
            endDate: data.end_date,
            price: data.price,
            discountedPrice: data.discounted_price,
            programBannerUrl: data.program_banner_url,
            activeBannerUrl: data.active_banner_url,
            benefitFlag: data.benefit_flag,
            extraBenefit: new ExtraBenefit({
                freeInsurance: new FreeInsurance({
                    active: freeInsurance.active,
                    maxPrice: freeInsurance.max_price
                }),
                onTimeGuarantee: new OnTimeGuarantee({
                    active: data.extra_benefit.on_time_guarantee.active,
                    type: data.extra_benefit.on_time_guarantee.type,
                    value: data.extra_benefit.on_time_guarantee.value,
                    disburseOption: data.extra_benefit.on_time_guarantee.disburse_option
                })
            }),
            duration: data.duration,
            tnc: data.tnc,
            createdAt: data.created_at,
            updatedAt: data.updated_at,
            createdBy: data.created_by,
            updatedBy: data.updated_by,
            status: data.status
        });
    }
}